export const CTMS_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://carrier.superdispatch.com'
    : 'https://carrier.staging.superdispatch.org';

export const LOADBOARD_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://api.loadboard.superdispatch.com'
    : 'https://api.loadboard.staging.superdispatch.org';

export const FUEL_FINDER_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://fuel-finder.superdispatch.com'
    : 'https://fuel-finder.staging.superdispatch.org';

export const CTMS_WEBSOCKET_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'wss://carrier.superdispatch.com/ws'
    : 'wss://carrier.staging.superdispatch.org/ws';

export const MEDIA_SERVICE_API_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://media.superdispatch.com'
    : 'https://media.staging.superdispatch.org';

export const REPORTING_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://reporting.api.private.superdispatch.com'
    : 'https://reporting.api.private.staging.superdispatch.org';

export const FRAUD_MONITOR_HOST =
  import.meta.env.VITE_APP_TARGET === 'production'
    ? 'https://fraud-monitor.superdispatch.com'
    : 'https://fraud-monitor.staging.superdispatch.org';
